<template>
  <!------------------------------------------
    An alert for when content is new or updated.
    Consider using this within the slot of the TimeLimitedContent component.
  -------------------------------------------->
  <div class="update-alert" :class="noBottomMargin === true ? 'no-bottom-padding' : ''">
    <v-icon class="alert-icon" color="#b31308" size="32">
      {{ icons[icon] }}
    </v-icon>
    <div>
      <div v-if="text">
        {{  text }}
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mdiHumanHandsup, mdiAlertCircleOutline } from '@mdi/js'

export default {
  name: 'AlertContentUpdate',
  props: {
    text: { type: String, required: false },
    noBottomMargin: { type: Boolean, required: false, default: false },
    icon: { type: String, required: false }
  },
  data () {
    return {
      icons: {
        'person': mdiHumanHandsup,
        'alert': mdiAlertCircleOutline
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/scss/vars.scss';

.update-alert {
  margin: 1.5rem auto 1.5rem auto;
  display: flex;
  align-items: center;
  border-top-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  border: 1px solid $header-red;
  padding: 0.4rem;
  background-color: $extra-subtle-red;
  font-size: 0.9rem;

  &.no-bottom-padding {
    margin-bottom: 0;
  }

  div {
    padding: 0.2rem 0;
  }

  .alert-icon {
    margin: 0.25rem 1rem 0.25rem 0.5rem;
  }
}
</style>


